import { AICHAlpha } from '@/modules/ai-features/views/aich-alpha'

export const AICHAlphaPage = () => {
  return <AICHAlpha />
}
